import styled from '@emotion/styled';
import { rem } from 'polished';

export const RCTContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  padding-bottom: ${rem('20px')};
`;

export const RCTContentContainer = styled.div<{ backgroundColor?: string }>`
  max-width: ${rem('1240px')};
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 0 ${rem('10px')};
  width: 100%;
  background-color: ${props => props.backgroundColor || '#f5f5f5'};
`;

export const RCTHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);
  z-index: 4;
  position: sticky;
  top: ${rem('105px')};

  /* When ProductHeaderBannerScroll is visible, push table header below it */
  body.has-phb-scroll & {
    top: ${rem('250px')};
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    top: ${rem('58px')};
    z-index: 6;

    body.has-phb-scroll & {
      top: ${rem('58px')};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.md - 1}px) {
    top: ${rem('58px')};
    z-index: 6;

    body.has-phb-scroll & {
      top: ${rem('58px')};
    }
  }
`;
